// PLACE_THREAD(1, "chat"), PLACE_PHOTO(3, "photo"), PLACE_PROFILE(2, "profile"), PLACE_VIDEO_CHAT(3, "videocall")
export enum IUserUtilsComplaintPlace {
  'chat' = 1,
  'profile' = 2,
  'photo' = 3,
  'videocall' = 4,
}

export interface IUserAPIUtilsComplaintPayload {
  typeId: number
  placeId: number
  userId: number
  photoId: number
  comment: string
}

export interface IUserAPIUtilsComplaintResponse {
  success: boolean
}
